import React, { useState, useEffect, useRef, useContext } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { markCommsProcessed, sendSingleSms } from '../../common/api';
import { isToday, isThisWeek } from '../../common/utils';
import BusinessIcon from '@mui/icons-material/Business';
import { RiContactsLine } from 'react-icons/ri';
import BoltIcon from '@mui/icons-material/Bolt';
import Copilot from './copilot';
import { toast } from 'react-toastify';
// import EmailSingle from '../../components/Panels/Email';
import { franc } from 'franc';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { getAITranslation } from '../../common/api';
import { CommsPanelCtx } from '../../contexts';


const Inbox = ( { org, aid, uid, user, viewing, comms, contacts } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    const [ loading, setLoading ] = useState( true );
    const [ suggestionLoading, setSuggestionLoading ] = useState( {} );
    const [ conRows, setConRows ] = useState( [] );
    const [ showConvo, setShowConvo ] = useState( false );
    const [ showAI, setShowAI ] = useState( false );
    const [ selectedContact, setSelectedContact ] = useState( '' );
    const [ messages, setMessages ] = useState( [] );
    const [ phones, setPhones ] = useState( [] );
    const [ sendTo, setSendTo ] = useState( '' );
    const [ sendFrom, setSendFrom ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ hasNoPhone, setNoPhone ] = useState( true );
    const [ hasNoSenderPhone, setNoSenderPhone ] = useState( true );
    const [ handled, setHandled ] = useState( false );
    const [ newMsg, setNewMsg ] = useState( '' );
    const [ sending, setSending ] = useState( false );
    const [ aiEnabled, setAiEnabled ] = useState( false );
    const [ showEmail, setShowEmail ] = useState( false );

    const { addPanel, closePanel } = useContext( CommsPanelCtx );

    let params = useParams();
    
    const gridRef = useGridApiRef();

    const containerRef = useRef();
    const msgRef = useRef();
    
    const askLeo = async ( idx, type, text ) => {
        setSuggestionLoading( prev => { return { ...prev, [idx]: true } } );
        const comm = comms[idx];

        console.log( 'asking leo: ', type, text );

        switch( type ) {
            case 'translate':
                const resp = await getAITranslation( comm.aid, uid, text );
                comms[idx].translation = resp.display;
                break;

            default:
                console.log( 'unknown askLeo type: ', type );
        }

        setSuggestionLoading( prev => { return { ...prev, [idx]: false } } );
    }

    const formatTime = ( d ) => {
        return d.toLocaleTimeString( 'en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        } );
    }

    const formatDay = ( d ) => {
        return d.toLocaleDateString( 'en-US', {
            weekday: 'long'
        } );
    }

    const formatDate = ( d ) => {
        return d.toLocaleDateString( 'en-US', {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric'
        } );
    }

    const displayName = ( cid ) => {
        let val;
        const fields = [ 'name', 'phoneMobile', 'phone', 'email' ];
        const c = contacts[cid];
        if ( c ) {
            for ( let i = 0; i < fields.length; i++ ) {
                if ( c[fields[i]] && c[fields[i]].length ) {
                    val = c[fields[i]];
                    break;
                }
            }
        }
        return val;
    }

    const displayDate = ( dd ) => {
        let val;
        const d = new Date( dd );
        
        if ( isToday( dd ) ) {
            val = formatTime( d );
        } else if ( isThisWeek( dd ) ) {
            val = formatDay( d );
        } else {
            val = formatDate( d );
        }

        return val;
    }

    const displayFlag = ( comm ) => {
        if ( comm.direction === 'outbound' || comm.processed ) {
            return <span className='no-dot'></span>;
        }
        return <span className='blue-dot'></span>;
    }

    const sendMsg = async ( d, t, tz ) => {
        setSending( true );

        const c = contacts[selectedContact];
        if ( !c ) {
            setSending( false );
            toast.error( `Something went wrong - can no longer find the contact!`, { theme: 'dark' } );
            return;
        }

        const msg = {
            to: {
                cid: c.cid,
                phone: sendTo,
            },
            from: sendFrom,
            contactId: c.cid,
            body: newMsg,
            // tmpl: tmplUsed,
            // attachments: attachments,
            // date: d,
            // time: t,
            // tz: tz,
            channel: 'sms'
        };

        console.log( 'msg: ', msg );

        let aid = c.aid;
        if ( c.shared === true ) {
            if ( viewing.length === 1 ) {
                aid = viewing[0];
            } else {
                const acct = user.additionalAccounts.find( f => {
                    if ( !viewing.includes( f.aid ) ) {
                        return false;
                    }

                    const a = user.lists.accounts.find( af => af.id === f.aid );
                    if ( a?.stack?.sms?.phone === sendFrom ) {
                        return true;
                    }
                    if ( a?.stack?.sms?.phones?.length ) {
                        const found = a.stack.sms.phones.find( s => s.number === sendFrom );
                        if ( found ) {
                            return true;
                        }
                    }
                    return false;
                } );
                if ( acct ) {
                    aid = acct.aid;
                }
            }
        }

        const sent = await sendSingleSms( aid, uid, msg );
        if ( sent.length ) {
            setSending( false );
            toast.success( `The Text has been Sent`, { theme: 'dark' } );
            setNewMsg( '' );
            console.log( 'sent resp: ', sent );
        } else {
            alert( 'We apologize - there was an error attempting to send your message - please notify the TF Support team' );
        }
    };

    const markProcessed = async () => {
        const comm = messages[messages.length - 1];
        const resp = await markCommsProcessed( comm.aid, uid, comm.cid );
        if ( resp && resp.length ) {
            toast.success( `The txt thread has been marked as processed.`, { theme: 'dark' } );
        } else {
            toast.error( `Something went wrong while marking the txt thread as processed.`, { theme: 'dark' } )
        }
    }

    const cols = [
        { field: 'display', headerName: 'Messages', flex: 1, renderCell: ( { row } ) => {
            const c = contacts[row.cid];
            const comm = row.comms[0];
            return ( 
                <Container>
                    <Link to={`/inbox/${c.cid}` } style={ { textDecoration: 'none' } }>
                        <Row className='align-items-center py-2'>
                            <Col xs={1} className='align-items-center p-0'>{displayFlag( comm )}</Col>
                            <Col xs={11} className='p-0'>
                                <Row className='align-items-center'>
                                    <Col className='fw-semibold fs-6'>{displayName( c.cid )}</Col>
                                    <Col xs='auto' className='text-right text-secondary align-items-center ps-0'>{displayDate( comm.createdDate )} <ChevronRightIcon /></Col>
                                </Row>
                                <Row>
                                    <Col className='text-secondary truncate-multiline'>{comm.details}</Col>
                                </Row>
                            </Col>
                        </Row>
                    </Link>
                </Container>
            );
        } }
    ];

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='p-0 align-items-center'>
                        <Col className='text-left'>
                            <GridToolbarQuickFilter />
                        </Col>
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const renderIcon = () => {
        let icon = <RiContactsLine />;
        const c = contacts[selectedContact];

        switch ( c.priRole ) {
            case 'partner':
                icon = <BusinessIcon />;
                break;

            default:
                
        }

        return icon;
    }

    const normalizePhone = ( phone ) => {
        const cleaned = ( '' + phone ).replace( /\D/g, '' );
        
        if (cleaned.length === 10) {
            const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if ( match ) {
                return `${match[1]}-${match[2]}-${match[3]}`;
            }
        }
        return phone;
    }

    useEffect( () => {
        document.title = 'Third Floor - Universal Inbox';
    }, [] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( showConvo ) {
            const c = conRows.find( f => f.cid === selectedContact );
            if ( c ) {
                const phones = [];
                const seen = new Set();

                if ( c.phoneMobile && c.phoneMobile.length ) {
                    const p = normalizePhone( c.phoneMobile );
                    phones.push( { label: 'Mobile', number: p } );
                    seen.add( p );
                }
                if ( c.phone && c.phone.length ) {
                    const p = normalizePhone( c.phone );
                    if ( !seen.has( p ) ) {
                        phones.push( { label: 'Phone', number: p } );
                        seen.add( p );
                    }
                }
                if ( c.phoneWork && c.phoneWork.length ) {
                    const p = normalizePhone( c.phoneWork );
                    if ( !seen.has( p ) ) {
                        phones.push( { label: 'Work', number: p } );
                        seen.add( p );
                    }
                }
                if ( c.phoneHome && c.phoneHome.length ) {
                    const p = normalizePhone( c.phoneHome );
                    if ( !seen.has( p ) ) {
                        phones.push( { label: 'Home', number: p } );
                    }
                }

                if ( phones.length ) {
                    setSendTo( phones[0].number );
                } else {
                    setSendTo( '' );
                }

                setPhones( phones );
                setMessages( [ ...c.comms ].reverse() );
            }
        } else {
            setMessages( [] );
            setPhones( [] );
            setSendTo( '' );
            setSendFrom( '' );
        }
    }, [ showConvo, selectedContact, conRows ] );

    useEffect( () => {
        if ( messages && messages.length ) {
            const latest = messages[messages.length-1];
            if ( latest ) {
                setHandled( latest.processed || latest.direction === 'outbound' );
            }
            if ( msgRef.current ) {
                msgRef.current.scrollTop = msgRef.current.scrollHeight;
            }
        }
    }, [ messages ] );

    // useEffect( () => {
    //     const cons = {};
    //     const list = [];
    //     const conOrder = [];

    //     if ( comms ) {
    //         Object.keys( comms ).forEach( cid => {
    //             const comm = comms[cid];
    //             if ( !viewing.includes( comm.aid ) ) {
    //                 return;
    //             }

    //             if ( comm.commType !== 'sms' ) {
    //                 return;
    //             }

    //             if ( comm.assoc ) {
    //                 const langCode = franc( comm.details );
    //                 comm.lang = langCode;
    //                 // console.log( 'comm: ', comm );
    //                 list.push( comm );
    //             }
    //         } );
    //         list.sort( ( a, b ) => {
    //             const ad = new Date( a.createdDate );
    //             const bd = new Date( b.createdDate );
    //             return bd.getTime() - ad.getTime();
    //         } );

    //         list.forEach( comm => {
    //             comm.assoc.forEach( ca => {
    //                 if ( !conOrder.includes( ca.cid ) ) {
    //                     conOrder.push( ca.cid );
    //                 }
    //                 if ( !cons[ca.cid] ) {
    //                     cons[ca.cid] = [];
    //                 }
    //                 cons[ca.cid].push( comm );
    //             } );
    //         } );
    //         const cList = [];
    //         const sharePartners = ( org && org.sharePartners === true ) ? true : false;
    //         conOrder.forEach( cid => {
    //             const c = contacts[cid];
    //             if ( !c ) {
    //                 return;
    //             }

    //             if ( ( sharePartners && c.priRole === 'partner' ) || viewing.includes( c.aid ) ) {
    //                 cList.push( {
    //                     id: c.cid,
    //                     ...c,
    //                     comms: cons[c.cid]
    //                 } );
    //             }
    //         } );

    //         setConRows( cList );
    //         setLoading( false );
    //     }
    // }, [ comms, contacts, viewing, org ] );

    useEffect(() => {
        if (!comms) return;
      
        // fast lookups
        const viewingSet = new Set(viewing);
        const consMap = new Map(); // cid -> array of comms
        const conOrder = []; // keep order
        const conOrderSet = new Set();
      
        // Build list of SMS comms for viewing accounts and compute timestamp once
        const smsList = [];
      
        for (const cid of Object.keys(comms)) {
            const comm = comms[cid];
            if (!comm) continue;
            if (!viewingSet.has(comm.aid)) continue;
            if (comm.commType !== 'sms') continue;
            if (!comm.assoc) continue;
        
            // Keep only fields we need for the list to reduce memory/copy cost
            const ts = Date.parse(comm.createdDate) || 0;
            smsList.push({
                __ts: ts,
                ...comm
            });
        }
      
        // sort once using numeric timestamps
        smsList.sort((a, b) => b.__ts - a.__ts);
      
        // build consMap and conOrder
        for (const comm of smsList) {
            for (const ca of comm.assoc) {
                const contactId = ca.cid;
                if (!conOrderSet.has(contactId)) {
                    conOrderSet.add(contactId);
                    conOrder.push(contactId);
                }
                const arr = consMap.get(contactId) || [];
                arr.push(comm);
                consMap.set(contactId, arr);
            }
        }
      
        // Build contact rows (only for contacts we have)
        const sharePartners = !!(org && org.sharePartners === true);
        const out = [];
      
        for (const cid of conOrder) {
            const c = contacts[cid];
            if (!c) continue;
            if ((sharePartners && c.priRole === 'partner') || viewingSet.has(c.aid)) {
                out.push({
                id: c.cid,
                ...c,
                comms: consMap.get(cid) || []
                });
            }
        }
      
        setConRows( out );
        setLoading( false );
    }, [ comms, contacts, viewing, org ] );
      
    useEffect( () => {
        let list = [];
        const c = contacts[selectedContact];

        if ( c && user.additionalAccounts ) {
            const sharePartners = ( org && org.sharePartners === true ) ? true : false;
            user.additionalAccounts.forEach( f => {
                if ( sharePartners && c.priRole === 'partner' ) {
                    if ( viewing.includes( f.aid ) ) {
                        if ( typeof( f.sms ) === 'string' ) {
                            list.push( { label: `${f.aid} - ${f.sms}`, number: f.sms, aid: f.aid } );
                        } else {
                            for ( const s of f.sms ) {
                                list.push( { label: `${f.aid}:${s.label} - ${s.number}`, number: s.number, aid: f.aid } );
                            }
                        }
                    }
                } else {
                    if ( f.aid === c.aid ) {
                        if ( typeof( f.sms ) === 'string' ) {
                            list.push( { label: `${f.aid} - ${f.sms}`, number: f.sms, aid: f.aid } );
                        } else {
                            for ( const s of f.sms ) {
                                list.push( { label: `${f.aid}:${s.label} - ${s.number}`, number: s.number, aid: f.aid } );
                            }
                        }
                    }
                }
            } );
        } else if ( user.stack.sms && user.stack.sms.phones && user.stack.sms.phones.length ) {
            user.stack.sms.phones.forEach( p => list.push( { number: p.number, label: `${p.label} - ${p.number}` } ) );
        } else if ( user.stack.sms && user.stack.sms.phone ) {
            list.push( { number: user.stack.sms.phone, label: user.stack.sms.phone } );
        }

        if ( list.length ) {
            setSendFrom( list[0].number );
        }

        setSenderList( list );
    }, [ user, contacts, selectedContact, org, viewing ] );

    useEffect( () => {
        if ( user?.stack?.ai?.copilot?.active ) {
            setAiEnabled( true );
        } else {
            setAiEnabled( false );
        }
    }, [ user ] );

    useEffect( () => {
        if ( !sendTo || !sendTo.length ) {
            setNoPhone( true );
        } else {
            setNoPhone( false );
        }

        if ( !sendFrom || !sendFrom.length ){
            setNoSenderPhone( true );
        } else {
            setNoSenderPhone( false );
        }

        console.log( 'sendTo: ', sendTo );
        console.log( 'sendFrom: ', sendFrom );
    }, [ sendTo, sendFrom ] );

    useEffect( () => {
        if ( params.cid && contacts[params.cid] ) {
            setSelectedContact( params.cid );
            setShowConvo( true );
        } else {
            setShowConvo( false );
        }
    }, [ params.cid, contacts ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='p-0' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' xs={4} md={3} style={ { height: '100%' } }>
                    <div className='tf-section-container p-0' style={ { display: 'flex', height: `${gridHeight}px`, margin: '10px 5px 20px 20px' } }>
                        <DataGridPro
                            apiRef={gridRef}
                            loading={ loading }
                            rows={conRows}
                            columns={cols}
                            // density='compact'
                            // checkboxSelection
                            disableSelectionOnClick
                            // slots={ { toolbar: toolbar } }
                            // onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                            getRowHeight={ () => 'auto' }
                            sx={ {
                                border: 0
                            } }
                            hideFooter={true}
                        />
                    </div>
                </Col>
                <Col className='p-0' xs={ showAI ? 4 : 8} md={ showAI ? 6 : 9} style={ { position: 'relative', height: '100%' } }>
                    <div className='tf-section-container p-0' style={ { display: 'flex', height: `${gridHeight}px`, margin: `${ showAI ? '10px 5px 20px 5px' : '10px 20px 20px 5px' }` } }>
                        {
                            ( !showConvo ) ? (
                                <div className='d-flex justify-content-center align-items-center' style={ { height: '100%', width: '100%' } }>
                                    <div className='fw-semibold fs-5 text-center'>No Conversation Selected</div>
                                </div>
                            ) : (
                                <Container className="chat-container">
                                    <Row className='tf-contact-cv-name-container align-items-center' style={ { minHeight: '56px', maxHeight: '56px', lineHeight: '56px', borderBottom: '1px solid rgba( 224, 224, 224, 1 )' } }>
                                        <Col className='fs-6' xs='auto'>
                                            { renderIcon() }
                                            <span className='ps-3 fw-bold'><Link to={`/contact/${selectedContact}`}>{displayName( selectedContact )}</Link></span>
                                        </Col>
                                         <Col className='text-end'>
                                            {
                                                ( !handled ) ? (
                                                    <Dropdown as={ButtonGroup}>
                                                        <Button className='tf-obj-button' size='sm' onClick={markProcessed}>Mark as Handled</Button>
                                                        {/* <Button className='tf-obj-button' size='sm' onClick={ () => addPanel( { obj: contacts[params.cid], objType: 'contact' } ) }>Show Email</Button> */}
                                                    </Dropdown>
                                                ) : (
                                                    null
                                                )
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="chat-messages" ref={msgRef}>
                                        <Col>
                                            { messages.map( ( msg ) => (
                                                <div key={msg.id}>
                                                    <div className={`message-container ${msg.direction === 'inbound' ? 'justify-content-start' : 'justify-content-end'}`}>
                                                        <div className={`message ${msg.direction}`} dangerouslySetInnerHTML={ { __html: msg.details } }></div>
                                                    </div>
                                                    {
                                                        ( msg.lang && msg.lang === 'spa' ) ? (
                                                            <div className={`message-container ${msg.direction === 'inbound' ? 'justify-content-start' : 'justify-content-end'}`}>
                                                                <Col xs='auto' className={`${msg.direction} p-0 leo-suggestion`} style={ { maxWidth: '60%' } }>
                                                                {
                                                                    ( msg.translation ) ? (
                                                                        <Row className='p-1 text-primary'>
                                                                            <Col xs='auto' className='pe-1'>
                                                                                <AutoAwesomeIcon style={ { fontSize: '26px' } } className='pe-1' />
                                                                            </Col>
                                                                            <Col className='ps-0 pt-1'>{msg.translation}</Col>
                                                                        </Row>
                                                                    ) : (
                                                                        suggestionLoading[msg.cid] ? (
                                                                            <Row className='p-1 text-secondary'>
                                                                                <Col xs='auto' className='pe-1'>
                                                                                    <AutoAwesomeIcon style={ { fontSize: '26px' } } className='pe-1' />
                                                                                </Col>
                                                                                <Col className='ps-0 pt-1'><Spinner animation='border' size='sm' /></Col>
                                                                            </Row>
                                                                        ) : (
                                                                            <Button size='sm' style={ { fontSize: '12px', textDecoration: 'none' } } variant='link' className='leo-suggestion-button' onClick={ () => askLeo( msg.cid, 'translate', msg.details ) } disabled={suggestionLoading[msg.cid]}>
                                                                                <Row>
                                                                                    <Col xs='auto' className='pe-1'>
                                                                                        <AutoAwesomeIcon style={ { fontSize: '26px' } } className='pe-1' />
                                                                                    </Col>
                                                                                    <Col className='ps-0 pt-1'>Translate to English</Col>
                                                                                </Row>
                                                                            </Button>
                                                                        )
                                                                    )
                                                                }
                                                                </Col>
                                                            </div>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                    <div className={`message-container ${msg.direction === 'inbound' ? 'justify-content-start' : 'justify-content-end'}`}>
                                                        <div className={` ${msg.direction}`}>
                                                            {displayDate( msg.createdDate )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) ) }
                                        </Col>
                                    </Row>
                                    <Row className="chat-input-container">
                                        <Col className='chat-msg-box'>
                                            <Row>
                                                <Col>
                                                {
                                                    hasNoPhone ? (
                                                        <div className='p-2 fw-bold text-danger'>Missing Phone Number - Unable to Send</div>
                                                    ) : (
                                                        ( phones.length === 1 ) ? (
                                                            <div className='p-2 fw-bold'>Sending To: {sendTo}</div>
                                                        ) : (
                                                            <Form.Group as={Row} className='tf-form-group align-items-center'>
                                                                <Form.Label column xs='auto'><span className='p-2 pe-0 fw-bold'>Sending To:</span></Form.Label>
                                                                <Col xs='auto' className='tf-form-select-field me-1 p-0'>
                                                                    <Form.Select size='sm' className='tf-modal-select-input ps-0' value={sendTo} onChange={ ( e ) => setSendTo( e.target.value ) }>
                                                                        {
                                                                            phones.map( ( p, idx ) => <option key={idx} value={p.number}>{p.label} - {p.number}</option>)
                                                                        }
                                                                    </Form.Select>
                                                                </Col>
                                                            </Form.Group>
                                                        )
                                                    )
                                                }
                                                </Col>
                                                <Col xs='auto' className='text-end pe-4'>
                                                {
                                                    hasNoSenderPhone ? (
                                                        <div className='p-2 fw-bold text-danger'>No Account Phone Number - Unable to Send</div>
                                                    ) : (
                                                        ( senderList.length === 1 ) ? (
                                                            <div className='p-2 fw-bold'>Sending From: {sendFrom}</div>
                                                        ) : (
                                                            <Form.Group as={Row} className='tf-form-group align-items-center'>
                                                                <Form.Label column xs='auto'><span className='p-2 pe-0 fw-bold'>Sending From:</span></Form.Label>
                                                                <Col xs='auto' className='tf-form-select-field me-1 p-0'>
                                                                    <Form.Select size='sm' className='tf-modal-select-input ps-0' value={sendFrom} onChange={ ( e ) => setSendFrom( e.target.value ) }>
                                                                        {
                                                                            senderList.map( ( p, idx ) => <option key={idx} value={p.number}>{p.label}</option>)
                                                                        }
                                                                    </Form.Select>
                                                                </Col>
                                                            </Form.Group>
                                                        )
                                                    )
                                                }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        className="chat-input"
                                                        value={newMsg}
                                                        onChange={ ( e ) => setNewMsg( e.target.value ) }
                                                        placeholder="Type a message..."
                                                        style={ { border: 0 } }
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='text-start'>
                                                    {
                                                        ( aiEnabled ) ? (
                                                            <Button className="inbox-button" onClick={ () => setShowAI( !showAI ) }><BoltIcon /></Button>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </Col>
                                                <Col className='pe-4 text-end'>
                                                    <Dropdown as={ButtonGroup} disabled={sending}>
                                                        <Button className="inbox-button" disabled={hasNoPhone || hasNoSenderPhone || sending} onClick={sendMsg}>Send</Button>
                                                        {/* <Dropdown.Toggle split className="inbox-button" id="dropdown-basic" disabled={hasNoPhone || hasNoSenderPhone}>
                                                            <FaChevronDown />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item href="#/action-1">Schedule</Dropdown.Item>
                                                        </Dropdown.Menu> */}
                                                    </Dropdown>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container>
                            )
                        }
                    </div>
                    {/* <EmailSingle open={showEmail} onClose={ () => setShowEmail( false ) } obj={contacts[params.cid]} objType='contact' /> */}
                </Col>
                {
                    showAI ? (
                        <Col className='p-0' xs={4} md={3} style={ { height: '100%' } }>
                            <div className='tf-section-container p-0' style={ { display: 'flex', height: `${gridHeight}px`, margin: '10px 20px 20px 5px' } }>
                                <Copilot cid={selectedContact} setMsg={setNewMsg} />
                            </div>
                        </Col>
                    ) : (
                        null
                    )
                }
            </Row>
        </Container>
    );
}

const mapProps = ( state ) => ( {
    org: state.user.org,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    comms: state.comms.byId,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Inbox );